import groupModule from '../groupModule';

function groupStoreController(
  $scope,
  $filter,
  groupStoreService,
  groupDetailsConstants,
  thumbnailConstants,
  cursorPaginationService,
  creatorTypeConstants
) {
  'ngInject';

  $scope.getDevelopPageUrl = function () {
    return `/develop/groups/${$scope.library.currentGroup.group.id}?view=11`;
  };

  $scope.getCatalogPageUrl = function () {
    return `/catalog?Category=3&Subcategory=3&CreatorType=${creatorTypeConstants.creatorTypes.group}&CreatorName=${encodeURIComponent($scope.library.currentGroup.group.name)}`;
  };

  $scope.storePager = cursorPaginationService.createPager({
    sortOrder: cursorPaginationService.sortOrder.Desc,
    pageSize: groupDetailsConstants.storePageSize,
    loadPageSize: groupDetailsConstants.cursorPageLoadSize,

    getCacheKeyParameters(params) {
      return {
        category: params.category,
        sortType: params.sortType,
        creatorType: params.creatorType,
        creatorTargetId: params.creatorTargetId
      };
    },

    getRequestUrl() {
      return $filter('formatString')(groupDetailsConstants.urls.catalogSearch);
    },

    beforeLoad() {
      $scope.layout.isLoading = true;
      $scope.layout.loadError = false;
    },

    loadSuccess(items) {
      $scope.layout.isLoading = true;
      groupStoreService.getItemDetails(items).then(function (details) {
        if ($scope.layout.isInfiniteScroll) {
          // Append if infinite scroll
          $scope.storeItems = $scope.storeItems.concat(details.data);
        } else {
          $scope.storeItems = details.data;
        }
        $scope.layout.isLoading = false;
      });
    },

    loadError(errors) {
      $scope.storeItems = [];
      $scope.layout.isLoading = false;
      $scope.layout.loadError = true;
    }
  });

  $scope.init = function () {
    $scope.layout = {};
    $scope.layout.isInfiniteScroll = $scope.library.metadata.isPhone;
    $scope.storeItems = [];

    $scope.thumbnailTypes = thumbnailConstants.thumbnailTypes;

    $scope.storePager.setPagingParameter('category', 'Clothing');
    $scope.storePager.setPagingParameter('sortType', 'Updated');
    $scope.storePager.setPagingParameter('creatorType', 'Group');
    $scope.storePager.setPagingParameter('creatorTargetId', $scope.library.currentGroup.group.id);
    $scope.storePager.loadFirstPage();
  };

  $scope.init();
}

groupModule.controller('groupStoreController', groupStoreController);
export default groupStoreController;
